// extracted by mini-css-extract-plugin
export default {"headerCycleWrapper":"CiklusDetaljno_headerCycleWrapper__CMlza","headerCycleTitle":"CiklusDetaljno_headerCycleTitle__v15M1"};